
























































import Vue from 'vue';
import Preloader from '@/components/preloader/Preloader.vue';
import i18n from '@/i18n';
import toLocaleString from '@/utils/toLocaleString';

export default Vue.extend({
  name: 'CountWidget',
  components: { Preloader },

  props: {
    title: {
      type: String,
      required: false,
      default: String(i18n.t('pages.dashboard.defaultCountTitle')),
    },
    todayData: {
      type: [Number, String],
      required: true,
      default: 12,
    },
    yesterdayData: {
      type: [Number, String],
      required: false,
      default: null,
    },
    link: {
      type: String,
      required: false,
      default: '',
    },
    linkTitle: {
      type: String,
      required: false,
      default: String(i18n.t('pages.dashboard.moreLink')),
    },
    prefix: {
      type: String,
      required: false,
      default: '',
    },
    postfix: {
      type: String,
      required: false,
      default: '',
    },
    loadData: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  computed: {
    dataNotEqual(): boolean {
      return this.todayData !== this.yesterdayData;
    },
    dataTrendUp(): boolean {
      return this.todayData > this.yesterdayData;
    },
  },

  methods: {
    formatValue(value: number) {
      return toLocaleString(value);
    },
  },
});
